import axios from "axios";
import SideBar from "../pages/sidebar/ManagerSideBar";
import DashBoardNavbar from "../pages/navbar/DashBoardNavbar";
// export default ProjectDetails;
import * as React from 'react';
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useNavigate } from 'react-router';
import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";
import DragnDrop from "../../Utils/DragnDrop";

export const UploadContext = React.createContext();

const UploadManual = (props) => {
  // const submit = props.submit
  const getData = props.getData
  const modal4 = props.modal
  const setModal4 = props.setModal
  // const deleteArray2 = props.deleteArray2
  const id = props.currentID

  // const id = props.id

  // const cancelDelete = (e) => {
  //     e.preventDefault();
  //     setModal4(!modal4)
  // }

  return (
    <div>
      <Modal size="lg" isOpen={modal4} toggle={() => setModal4(!modal4)}>
        <ModalHeader toggle={() => setModal4(!modal4)}>
          Upload Video
        </ModalHeader>
        <ModalBody>
          <main className="main-content position-relative h-100 border-radius-lg">
            <UploadContext.Provider value={[modal4, setModal4, getData] }>
              <DragnDrop />
            </UploadContext.Provider>
          </main>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default UploadManual;
      